import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { empDeductionCreationValidation } from "core/Operations/ValidationSchema/payrollValidation";
import EmpDeductionForm from "Components/Form/EmpDeductionForm";
import { useInsertEmpDeductionMutation } from "AppQuries/payroll/deduction/emp-deduction";
import { toast } from "core/Operations/toast";
const AddEmpDeduction = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addEmpDeduction,
    isPending,
    isError,
    error,
  } = useInsertEmpDeductionMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      code: "",
      employeeCode: "",
      departmentCode: "",
      description: "",
      haveCPF: true,
      isTaxPayable: true,
      amount: "",
      isActive: true,
      createUser: userData.userName,
      //   createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      //   modifyUser: userData.userName,
      //   modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
    },
    resolver: yupResolver(empDeductionCreationValidation),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    console.log(payload);
    addEmpDeduction(payload, {
      onSuccess: (data) => {
        if (data[0]?.response === true) {
          toast.success("Employee Deduction Added Successfully.");

          setTimeout(() => {
            navigate(`${all_routes.emp_deductions}`);
          }, 1000);
        } else {
          toast.warning(data[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add Employee Deduction</h4>
                    <h6>Add Employee Deduction details </h6>
                  </div>
                </div>

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="back-tooltip">Back</Tooltip>}
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.emp_deductions}`}
                    >
                      <i className="fa fa-reply me-2"></i>
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save Employee Deduction
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add Employee Deduction</h4>
                    </div>
                    <div className="card-body">
                      <EmpDeductionForm mode="A" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddEmpDeduction;
